/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Option } from "@nordcloud/gnui/dist/components/dropdown/types";
import { Select, Spacer, Text } from "@nordcloud/gnui";
import { InlineEditForm } from "~/components/InlineEdit/InlineEditForm";
import { StyledOutsideLink } from "~/components/Styled/Common";

import { displayProvidersIcons } from "~/tools/display/displayProvidersIcons";

type Props = {
  options: Option[];
  defaultValue: string[];
  onSubmit: (value: string[]) => Promise<void>;
  canEdit?: boolean;
  providerIcons?: boolean;
  width?: string;
  hrefBase?: string;
};

function InlineEditMultiSelect({
  options,
  defaultValue,
  onSubmit,
  canEdit,
  providerIcons,
  hrefBase = "",
  width = "25rem",
}: Props) {
  const [value, setValue] = React.useState<string[]>(defaultValue);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [setValue, defaultValue]);

  const optionsArray = options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  );

  let display;
  if (providerIcons) {
    display = displayProvidersIcons(
      optionsArray.filter((o) => value.includes(o.value))
    );
  } else {
    display =
      hrefBase && defaultValue ? (
        defaultValue.map((v) => (
          <>
            <StyledOutsideLink key={v} href={hrefBase + v}>
              {optionsArray.find((o) => o.value === v)?.label || "–"}
            </StyledOutsideLink>
            <Spacer margin="0.3rem" />
          </>
        ))
      ) : (
        <Text m="0">
          {defaultValue
            .map((v) => optionsArray.find((o) => o.value === v)?.label)
            .join(", ") || "–"}
        </Text>
      );
  }

  return (
    <InlineEditForm
      onSubmit={async () => onSubmit(value)}
      display={display}
      canEdit={canEdit}
    >
      <Select
        css={{ width, minWidth: "15rem" }}
        isMulti
        // @ts-expect-error there is a bug with type generation in GNUI
        onChange={(newValue: any[]) => setValue(newValue.map((v) => v.value))}
        value={optionsArray.filter((opt) => value.includes(opt.value))}
        options={optionsArray}
      />
    </InlineEditForm>
  );
}

export { InlineEditMultiSelect };
